import { Constants } from "appConstants";
import { baseConfig } from "config";
import { ErrorHelper } from "helpers";
import { CurrentUser } from "models/auth/CurrentUser";
import { CurrentUserData } from "models/auth/types";
import { CurrentUserAction } from "providers/currentUserReducer";
import { toast } from "react-toastify";
import { BaseServices } from "./baseServices";

export class AuthService extends BaseServices<CurrentUserData, CurrentUser> {
	constructor() {
		super(CurrentUser);
	}
	async loginB2C() {
		const client_id = baseConfig.b2cClientId;
		const redirect = `${window.location.protocol}//${window.location.host}`;
		const b2c_url = baseConfig.b2cUrl;
		const loginURL = `${b2c_url}/oauth2/v2.0/authorize?p=B2C_1_SUSI&client_id=${client_id}&nonce=defaultNonce&scope=openid&response_type=id_token&prompt=login&redirect_uri=${redirect}/confirm-login`;

		window.location.assign(loginURL);
	}

	async loginAD() {
		const redirectURI = `${window.location.protocol}//${window.location.host}`;
		const loginURL = `${baseConfig.baseURL}/oauth2/authorize/azure?redirect_uri=${redirectURI}/backoffice/`;
		window.location.assign(loginURL);
	}

	async logout(
		dispatch: React.Dispatch<{ type: CurrentUserAction }> | null,
		showMessage = true
	) {
		return this.get("auth/logout")
			.then(() => {
				dispatch?.({ type: CurrentUserAction.LOGOUT });
				if (showMessage) {
					toast.success(Constants.textLogout);
				}
			})
			.catch((error) => {
				ErrorHelper.showErrorMessage(error);
			});
	}

	static getInstance() {
		return new AuthService();
	}
}
